module.exports = __webpack_public_path__ + "static/img/step2.3c095ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/businessFlow/step2.png
// module id = hAUJ
// module chunks = 1